module.exports = __webpack_public_path__ + "static/HungNguyen-e7d7089ab896c9e1d2bb95c24ab4d528.svg";